import { VideoJsPlayer } from "video.js";
import { IPlayerConfig } from "models/player-config.model";
import { setDefaultStyleSubtitle, Subtitles } from "functions/Subtitles";
import { getCurrentVideo } from "helpers/current-video.helper";
import { CustomizePlayer } from "functions/Customize";
import { CustomizePlaylist } from "functions/CustomizePlaylist";
import '../assets/nuevo/playlist';
import { IMedia } from "models/media.model";
import { Chapters } from "functions/Chapters";
import { injectScript } from "helpers/script-inject.helper";
import '../assets/nuevo/videojs.hotkeys';
import { BuildChapters } from "functions/BuildChapters";
import { playerEventHandler } from "events/player.events";
import { AddChaptersMarkers } from "functions/ChaptersMarkers";

export interface IPlayerReadyOption {
  player: VideoJsPlayer,
  config: IPlayerConfig,
  openChapterPanel: () => void
}

export function PlayerReady({player, config, openChapterPanel}: IPlayerReadyOption): void {


  playerEventHandler(config, player);
  let currentVideo: IMedia = getCurrentVideo(player, config.media);

  // init loop when no ads
  if (config.player.ads === undefined) {
    player.loop(config.player.show_loop);
  }

  player.on('playlistitem', () => {
    currentVideo = config.media[player.playlist.currentIndex()];
    if (currentVideo.chapters) {
      Chapters({url: currentVideo.chapters}).then((chapters) => {

        if (chapters && chapters.length) {
          BuildChapters({
            player,
            chapters,
            openChapterPanel,
            chapterUrl: currentVideo.chapters,
            hasSubtitles: !!currentVideo.subtitles?.length
          })
        }
      })
    }
  });

  player.one('play', () => {
    if (config.media.length > 1) {
      currentVideo = config.media[player.playlist.currentIndex()];
    }

    if (currentVideo?.subtitles !== void 0) {
      Subtitles(currentVideo as any, player);
    }

    player.setRate(config.player.default_speed ?? 1);
    player.volume(config.player.audio_volume ?? 100);

  });

  const initVr = () => {
    if (player?.vr !== undefined) {
      const media_vr_type = currentVideo?.side_data?.find(value => value.type)?.type;

      if (media_vr_type !== void 0) {

        if (media_vr_type === '2D') {
          player.vr({
            projection: 'equirectangular',
            motionControls: true,
          });
        } else if (media_vr_type === 'top and bottom') {
          player.vr({
            projection: '360_TB',
            motionControls: true,
          });
        } else {
          player.vr({
            projection: '360_TB',
            motionControls: true,
          });
        }
      } else {
        player.vr({
          projection: '360_TB',
          motionControls: true,
        });
      }
    }
  }


  let lastState = false;
  let chaptersAlreadBuild = false;

  const observer = new MutationObserver(() => {
    const isAdPlaying = player.el().classList.contains('vjs-ad-playing');

    const buildChapters = () => {
      if (currentVideo.chapters) {
        Chapters({url: currentVideo.chapters}).then((chapters) => {
          if (chapters && chapters.length) {
            BuildChapters({
              player,
              chapters,
              openChapterPanel,
              chapterUrl: currentVideo.chapters,
              hasSubtitles: !!currentVideo.subtitles?.length
            })
            AddChaptersMarkers({ chapters: chapters, player: player, config: config.player, currentVideo });
            chaptersAlreadBuild = true;
          }
        })
      }
    }

    if (isAdPlaying !== lastState) {
      lastState = isAdPlaying; // Met à jour l’état précédent

      if (!isAdPlaying && !chaptersAlreadBuild) {
        buildChapters()
        player.loop(config.player.show_loop);

      }
    } else {
      if (!chaptersAlreadBuild) {
        buildChapters();
      }
    }
  });

  observer.observe(player.el(), { attributes: true, attributeFilter: ['class'] });

  player.one('play', () => {

    setDefaultStyleSubtitle(player);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const time = Number(params.get('t'));

    if (time !== void 0 && time !== null && currentVideo?.duration !== null && time < currentVideo?.duration) {
      player.currentTime(Number(time))
    }


    if (config.player.is360) {
      injectScript('videojs.vr.js').onload = () => {
        player.vr()
      }
    }


  })


  // init hotkeys
  player.hotkeys();

  // init customize player
  CustomizePlayer(config.player, config.media.length, player);

  // init customize playlist style
  if (config.media.length > 1) {
    CustomizePlaylist(config.playlist)
  }


  injectScript('videojs-chromecast.min.js').onload = () => {
      player.chromecast({
        metaTitle: currentVideo.title,
        metaSubtitle: '',
        metaThumbnail: currentVideo.thumbnails.poster,
      });
  };

}
